var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-logo pa-3",attrs:{"to":_vm.noHref ? '' : '/'}},[_c('img',{attrs:{"src":"/admin-static/iz-teach-logo.jpg","alt":"logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }